import React from "react";
import teamImg from "./assets/img/team/team.jpg";
import "./assets/style/Team.css";

function Team() {
  return (
    <section id="team" className="team">
      <div className="container" data-aos="fade-up">
        <div className="team-image-container" data-aos="zoom-in" data-aos-delay="200">
          <img 
            src={teamImg} 
            className="team-photo" 
            alt="Zespół Natchnienie Studio - instruktorki jogi, pilatesu i fitnessu w Gdańsku" 
          />
          <div className="team-overlay">
            <div className="team-text">
              <h2>Nasz Zespół</h2>
              <p>Razem tworzymy wyjątkową atmosferę w Natchnieniu</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
